<template>
    <div v-show="showLoading" class="card position-absolute top-50 start-50 end-50 PleaseWait">
        <div class="card-body align-center">
			<img src="Images/ajax-loader.gif" alt="The page is loading"/>
            <span class="fw-bold ps-1">Loading...</span> 
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, watch, PropType } from 'vue';

const props = defineProps<{
    showLoading:boolean
}>()
</script>